import { render, staticRenderFns } from "./unmatch-agent-modal.vue?vue&type=template&id=29835cc6&scoped=true&"
import script from "./unmatch-agent-modal.vue?vue&type=script&lang=js&"
export * from "./unmatch-agent-modal.vue?vue&type=script&lang=js&"
import style0 from "./unmatch-agent-modal.vue?vue&type=style&index=0&id=29835cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29835cc6",
  null
  
)

component.options.__file = "unmatch-agent-modal.vue"
export default component.exports